import {
  NotificationQuestSuccessState,
  NotificationState,
} from "@/domains/notification/constants/notificationState";

export default function isQuestSuccessNotification(
  notification: NotificationState,
): notification is NotificationQuestSuccessState {
  return (notification as NotificationQuestSuccessState).exp !== undefined;
}
